// Main file, basically just loads the app file
require("./polyfills/polyfills.js");
import App from './components/app'
import React from 'react'
import { createRoot } from "react-dom/client";

const container = document.getElementById("app");
const root = createRoot(container);

window.React = root.render(<App />);
